<script>
	export let layout;
	export let index = 0;
	$: pos = layout.xAt(index);
	$: plot = layout.plot;
</script>

<g class="crosshair" data-export="skip">
	{#if layout.horizontal}
		<line x1={plot.x} x2={plot.x + plot.w} y1={pos} y2={pos} />
	{:else}
		<line x1={pos} x2={pos} y1={plot.y} y2={plot.y + plot.h} />
	{/if}
	{#if layout.isLine}
		{#each layout.lines as l}
			{#if l.points[index]}
				<circle cx={l.points[index].x} cy={l.points[index].y} r={layout.dotRadius + 1} style="--c:{l.color}" />
			{/if}
		{/each}
	{/if}
</g>

<style>
	line {
		stroke: var(--_axis);
		stroke-width: 1;
		pointer-events: none;
	}

	circle {
		fill: var(--c);
		stroke: var(--_surface);
		stroke-width: 2;
		pointer-events: none;
	}
</style>
